import React from 'react';
import {withRouter} from 'react-router-dom';
import {saveCourseRecord} from "../../api/course-record";
import ButtonComponent from "../../../components/button/button";
import styles from './course.css';
import cn from "classnames";
import BannerInfo from "../../components/banner-info/banner-info";
import {COURSE_ACCESS_CLASS_CODE} from "../../lib/constant";
import Message from "../../components/message/message";
import {showLoading} from "../../components/loading/loading";
import ModalManager from "../../components/modal/modal-manager";
import LoginRegModal from "../../components/login-reg-modal/login-reg-modal";
import {setCourseRecords, setMyProjects,setCourses, setUser} from "../../reducers/teach";
import ClazzCodeFormModal from "./clazz-code-form-modal";
import AddClassConfirm from "./addClass-confirm";

const CourseBanner = ({course: {id, name, cover, desc, record, clazz_course}, clazz_id, clazz_code, onJoinCourse, history,props}) => {

    const showInputClazzCode = () => {
        ModalManager.open(ClazzCodeFormModal, {
            onClose: () => {},
            onSubmit: value => {
                clazz_code = value;
                joinCourse();
            }
        });
    };

    if(!record){
        ModalManager.open(AddClassConfirm, {
            onClose: () => {},
            onSubmit: value => {
                clazz_code = value;
                joinCourse();
            }
        },'addCourse');
        
    }

    const showLogin = () => {
        ModalManager.open(LoginRegModal,{
            closeAfterSubmit: true,
            onClose: () => {},
            setUser, setCourseRecords, setMyProjects,setCourses, showLoading
        }, 'login');
    }

    const joinCourse = () => {
        let data = {
            course_id: id
        };
        if(props){
            if(!props.user || !props.user.id){
                showLogin()
                return;
            }
        }
        if(!clazz_course){
            Message.show("该课程需要先加入学校班级才能报名参加")
            return
        }
        
        if (clazz_id) data.clazz_id = clazz_id;
        if (clazz_code) data.clazz_code = clazz_code;
        if (clazz_id || clazz_code || clazz_course.access == 1 || clazz_course.access == 4) {
            saveCourseRecord(data, {showLoading: window.L("teach.loading.submit")}).then(
                () => {
                    Message.show(window.L('teach.course.joinSuccess'));
                    onJoinCourse();
                },
                error => {
                    if(error.code === -1){
                        onJoinCourse()
                    }
                    if (error.code == 1403) {
                        showInputClazzCode();
                    }
                }
            );
        }else {
            showInputClazzCode();
        }
    };
    return (
        <BannerInfo style={{width: "100%"}} title={name + (clazz_course && clazz_course.clazz ? '（' + clazz_course.clazz.name + '）' : '')} cover={id} desc={desc} buttons={
            id && (record ?
                    ((record.clazz_id == clazz_id || !clazz_id) ? (
                            <ButtonComponent
                                className={cn(styles.joinCourseBtn, styles.disable)}
                                disabled={true}>
                                已加入
                            </ButtonComponent>
                        ) : (
                            <div className={styles.antRow}>
                                <div className={styles.antCol24}>
                                    <div className={styles.antRow}>
                                        <span>尚未加入当前班级，但发现你在另外一个班级参加了这个课程，要到自己的班级吗？</span>
                                    </div>
                                    <div className={styles.antRow}>
                                        <ButtonComponent
                                            className={styles.button}
                                            onClick={()=>{
                                                history.push(`./course?clazz_id=${record.clazz_id}&id=${id}`);
                                            }}>
                                            跳转
                                        </ButtonComponent>
                                        <span style={{marginLeft:"1rem", marginRight:"1rem", marginTop:"0.4rem"}}>或</span>
                                        <ButtonComponent
                                            className={styles.joinCourseBtn}
                                            onClick={joinCourse}
                                        >
                                            加入当前班级
                                        </ButtonComponent>
                                    </div>
                                </div>
                            </div>
                        )
                    )
                    :
                    ((clazz_id && !clazz_course) ? (
                            clazz_id && <span style={{color: "red"}}>{window.L("teach.course.courseNotInTheClass")}</span>
                        ) : (
                            <ButtonComponent
                                className={styles.joinCourseBtn}
                                onClick={joinCourse}
                            >
                                加入课程
                            </ButtonComponent>
                        )
                    )
            )
        }/>
    );

};

export default withRouter(CourseBanner);
